module.exports = __webpack_public_path__ + "static/Saale-Unstrut2-scaled-93c0025c520dcfa9668ba9aa3b50917c.jpeg";